var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg006(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    fill: "#753CBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    fill: "white",
    stroke: "#753CBE",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26114 8.0001C8.26126 7.94836 8.24604 7.89776 8.21739 7.85468C8.18874 7.81161 8.14795 7.778 8.10019 7.75812C8.05243 7.73823 7.99985 7.73297 7.94909 7.74298C7.89834 7.753 7.8517 7.77785 7.81507 7.81438C7.77845 7.85092 7.75349 7.8975 7.74335 7.94823C7.73321 7.99896 7.73835 8.05156 7.75812 8.09936C7.77789 8.14717 7.8114 8.18804 7.8544 8.21679C7.89741 8.24555 7.94798 8.26089 7.99971 8.26089C8.06894 8.2609 8.13534 8.23344 8.18435 8.18455C8.23335 8.13566 8.26097 8.06932 8.26114 8.0001V8.0001Z",
    fill: "#753CBE",
    stroke: "#753CBE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00488 2.12622V2.99807",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00488 12.9338V13.8057",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8446 7.96631H12.9722",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03738 7.96631H2.16553",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0672 2.99365L10.6099 3.73636",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39973 12.1958L4.94238 12.9385",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1423 5.1897L12.375 5.6042",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63447 10.3276L2.86719 10.7421",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9771 11.0288L12.2344 10.5708",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77543 5.36091L3.03271 4.90356",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 13.1038L10.3667 12.3359",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64302 3.59614L5.22852 2.82886",
    stroke: "#753CBE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09146 14.8374C10.0258 14.8166 11.8731 14.073 13.227 12.7703C14.5809 11.4675 15.3305 9.71238 15.3108 7.89089C15.2912 6.0694 14.504 4.33079 13.1223 3.05754C11.7407 1.7843 9.87775 1.08071 7.94342 1.10155L8.01744 7.96949L8.09146 14.8374Z",
    fill: "#753CBE",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg006);
export default __webpack_public_path__ + "static/media/00-6.aedb09cffc3909694f6ef4e2bf182aaa.svg";
export { ForwardRef as ReactComponent };